webpackJsonp([4098895500148],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sections = [{
	  name: 'Why Lease',
	  path: 'why',
	  subsections: ['good-business', 'lease-loan', 'case-study', 'questions', 'history', 'press']
	}, {
	  name: 'Services',
	  path: 'services',
	  subsections: ['consulting', 'brokering', 'vendor']
	}, {
	  name: 'Experience',
	  path: 'experience',
	  subsections: ['memberships', 'testimonials']
	}, {
	  name: 'Contact',
	  path: 'contact'
	}, {
	  name: 'Links',
	  path: 'links'
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'sitemap' },
	    _react2.default.createElement(
	      'div',
	      { className: 'sitemap-hero' },
	      _react2.default.createElement('div', { className: 'sitemap-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'sitemap-title' },
	      'Sitemap'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'sections-wrap' },
	      sections.map(function (section, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'section', key: i },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'section-link' + (section.subsections ? '' : ' no-subsections'), to: '/' + section.path },
	            section.name
	          ),
	          section.subsections ? _react2.default.createElement(
	            'div',
	            { className: 'subsections-wrap' },
	            section.subsections.map(function (subsection, i) {
	              var formatted = subsection.includes('-') ? subsection.replace('-', ' ') : subsection;
	              if (subsection === 'lease-loan') formatted = 'Lease vs Loan';
	              return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'subsection-link', style: subsection === 'lease-loan' ? { textTransform: 'none' } : {}, key: i, to: section.path + '/' + subsection },
	                formatted
	              );
	            })
	          ) : null
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sitemap-js-71052d4ebae074978713.js